import React, { useState, useRef, useEffect } from 'react';
import { auth } from '../services/api';

export default function TwoFactorVerify({ tempToken, onSuccess, onBack }) {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleCodeChange = async (value) => {
    const digits = value.replace(/[^0-9]/g, '').slice(0, 6);
    setCode(digits);
    setError('');

    // Soumission automatique dès 6 chiffres
    if (digits.length === 6) {
      setLoading(true);
      try {
        const res = await auth.verify2fa(tempToken, digits);
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        onSuccess(res.data.user);
      } catch (err) {
        setError(err.response?.data?.error || 'Code incorrect ou expiré');
        setCode('');
        setLoading(false);
        setTimeout(() => inputRef.current?.focus(), 50);
      }
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
      padding: '24px',
    }}>
      <div style={{
        background: 'var(--bg-surface)',
        borderRadius: '16px',
        padding: '40px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center',
      }}>
        {/* Icône */}
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔐</div>

        {/* Titre */}
        <h1 style={{ fontSize: '22px', fontWeight: '700', color: 'light-dark(#1a1a2e, var(--color-info-dark))', margin: '0 0 8px' }}>
          Vérification en deux étapes
        </h1>
        <p style={{ fontSize: '14px', color: 'var(--text-secondary)', margin: '0 0 32px' }}>
          Entrez le code à 6 chiffres affiché dans<br />
          <strong style={{ color: 'var(--text-primary)' }}>Microsoft Authenticator</strong>
        </p>

        {/* Champ code */}
        <input
          ref={inputRef}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          maxLength={6}
          value={code}
          onChange={e => handleCodeChange(e.target.value)}
          placeholder="000000"
          disabled={loading}
          style={{
            width: '100%',
            padding: '16px',
            fontSize: '36px',
            fontWeight: '700',
            textAlign: 'center',
            letterSpacing: '14px',
            border: `2px solid ${error ? 'var(--color-error)' : code.length === 6 ? 'var(--color-success)' : 'var(--border-default)'}`,
            borderRadius: '12px',
            outline: 'none',
            boxSizing: 'border-box',
            color: '#1a1a2e',
            background: loading ? 'var(--bg-muted)' : 'var(--bg-surface)',
            transition: 'border-color 0.2s',
          }}
          autoComplete="one-time-code"
        />

        {/* Indicateur de progression */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginTop: '12px', marginBottom: '16px' }}>
          {[0,1,2,3,4,5].map(i => (
            <div key={i} style={{
              width: '8px', height: '8px', borderRadius: '50%',
              background: i < code.length ? '#C9A84C' : 'var(--border-default)',
              transition: 'background 0.15s',
            }} />
          ))}
        </div>

        {/* Erreur */}
        {error && (
          <div style={{
            background: 'var(--color-error-light)', border: '1px solid light-dark(#fecaca, var(--border-strong))',
            borderRadius: '8px', padding: '10px 14px',
            color: 'light-dark(var(--color-error), var(--color-error-dark))', fontSize: '13px', marginBottom: '16px',
            textAlign: 'left',
          }}>
            ⚠️ {error}
          </div>
        )}

        {/* Chargement */}
        {loading && (
          <p style={{ color: 'var(--text-secondary)', fontSize: '13px', margin: '0 0 16px' }}>
            Vérification en cours...
          </p>
        )}

        {/* Retour */}
        <button
          type="button"
          onClick={onBack}
          disabled={loading}
          style={{
            background: 'none', border: 'none',
            color: 'var(--text-muted)', fontSize: '13px',
            cursor: 'pointer', textDecoration: 'underline',
            marginTop: '8px',
          }}
        >
          ← Changer de compte
        </button>

        {/* Note */}
        <p style={{ fontSize: '11px', color: 'var(--text-muted)', marginTop: '20px', lineHeight: '1.5' }}>
          Le code se renouvelle toutes les 30 secondes.<br />
          Compatible avec Google Authenticator, Authy et tout app TOTP.
        </p>
      </div>
    </div>
  );
}
